<section class="nopad">
    <div class="container-fluid register">
        <div class="row">
            <div class="col-md-3 register-left">
                <div class="col-md-12 nopad">
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/AICTELogo.png" alt="Logo" style="margin-left: 25px;"></a>
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/SLALogo.png" alt="Logo"></a>
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/Parakhlogo.png" alt="Logo" style="height: 47px; margin-left: -20px;"></a>
                </div>
                <div class="col-md-12 nopad leftSection">
                    <img class="IconImg" src="https://image.ibb.co/n7oTvU/logo_white.png" alt="" />
                    <h3>Forgot your Password?</h3>
                    <p>Enter the details to reset your password!</p>
                    <p>Trying to Login?</p>
                    <a [routerLink]="['/login']" class="mt-3 registerBtn loginBtn">LOGIN</a>
                </div>
            </div>
            <div class="col-md-9 register-right">
                <form [formGroup]="forgotForm" (ngSubmit)="onSubmit(forgotForm.value)" class="registerFormContainer">
                    <h2 class="registerHeading">Reset Password via Email</h2>
                    <div class="text-center">
                        <a mat-button routerLink="/request-password-reset-otp" color="accent" class="w-100">Reset Password via SMS</a>
                        <mat-form-field [floatLabel]="'never'" class="w-100">
                            <mat-icon matPrefix class="mat-icon-sm mb-2 mr-2 secondary-text-color">mail</mat-icon>
                            <input matInput placeholder="Enter your Email" formControlName="email" autocomplete="new-password" maxlength="60">
                            <mat-error *ngIf="forgotForm.controls.email.errors?.required">Email is required</mat-error>
                            <mat-error *ngIf="forgotForm.controls.email.hasError('invalidEmail')">Invalid email address</mat-error>
                        </mat-form-field>
                        <div class="captchaContainerBorder">
                            <div class="captchaContainer">
                                <canvas #canvas2 id='canvas2' style="width: 50%; height: 96%;background: rgb(216, 215, 215);">captcha text</canvas>
                                <input class="captchaInput" id="textBox" type="text" name="text" (input)="change(input.value)" #input formControlName="captcha" maxlength="8">
                                <a style="cursor: pointer; margin-top: 5%;" (click)="refreshCaptcha()">
                                    <mat-icon>autorenew</mat-icon>
                                </a>
                            </div>
                        </div>
                        <button mat-raised-button class="mat-elevation-z6 w-100 mt-3 registerBtn" type="submit">Get Verification E-mail</button>
                    </div>

                </form>

            </div>
        </div>
    </div>
</section>